/** @deprecated Use status color from Skapa instead. */
enum StatusIndicatorColorEnum {
	red = 'red',
	orange = 'orange',
	green = 'green',
	grey = 'grey'
}
export default StatusIndicatorColorEnum;
